import {
  AutoAssessment,
  AutoEvaluation,
  JobDescription,
  JobPostingTabData,
  JobRequisition,
  jobOpeningTypes,
} from '../types/JobOpenings';
import { rtkApi } from './rtkApi';

export const jobOpeningsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getJobOpeningDetails: builder.query<any, string>({
      query: (id) => `/job-openings/${id}/details`,
      providesTags: (result, error, id) => [{ type: 'JobOpening', id }],
    }),
    getJobApplicants: builder.query<any, { id: string; search?: string; page?: number; limit?: number; status?: string }>({
      query: ({ id, search = '', page = 1, limit = 10, status = '' }) =>
        `/job-openings/${id}/applicants?search=${search}&page=${page}&limit=${limit}&status=${status}`,
      providesTags: (result, error, { id }) => [{ type: 'JobOpening', id }],
    }),
    editJobOpening: builder.mutation<any, { id: string; elements: jobOpeningTypes[] }>({
      query: ({ id, elements }) => ({
        url: `/job-openings/${id}`,
        method: 'PUT',
        body: { jobOpeningElements: elements },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'JobOpening', id }],
    }),
    createJobRequisition: builder.mutation<any, JobRequisition>({
      query: (body) => ({
        url: '/job-openings/job-requisitions',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
    createJobDescription: builder.mutation<any, JobDescription>({
      query: (body) => ({
        url: '/job-openings/job-descriptions',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
    createAutoSuitability: builder.mutation<any, AutoEvaluation>({
      query: (body) => ({
        url: '/job-openings/auto-suitability',
        method: 'POST',
        body: { ...body, id: undefined },
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
    createAutoOutstanding: builder.mutation<any, AutoEvaluation>({
      query: (body) => ({
        url: '/job-openings/auto-outstanding',
        method: 'POST',
        body: { ...body, id: undefined },
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
    createAutoAssessment: builder.mutation<any, AutoAssessment>({
      query: (body) => ({
        url: '/job-openings/auto-assessments',
        method: 'POST',
        body: { ...body, id: undefined },
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
    updateJobPosting: builder.mutation<any, JobPostingTabData>({
      query: (body) => ({
        url: '/job-openings/job-posting', // Assuming the endpoint from context
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { jobOpeningId }) => [{ type: 'JobOpening', id: jobOpeningId }],
    }),
  }),
});

export const {
  useGetJobOpeningDetailsQuery,
  useGetJobApplicantsQuery,
  useEditJobOpeningMutation,
  useCreateJobRequisitionMutation,
  useCreateJobDescriptionMutation,
  useCreateAutoSuitabilityMutation,
  useCreateAutoOutstandingMutation,
  useCreateAutoAssessmentMutation,
  useUpdateJobPostingMutation,
} = jobOpeningsApi;
